<template>
  <b-overlay
    :show="loader.calendario"
    opacity="0.50"
    rounded="sm"
  >
    <b-row>
      <b-col
        lg="9"
        md="9"
        sm="12"
      >
        <selectplan @selectedplan="idplan=$event" />
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="12"
      >    <selectperiodo
        :idplan="idplan"
        :limitado="true"
        @selectedperiodo="loadCalendario($event && $event.periodo ? $event.periodo: null)"
      />
      </b-col>
    </b-row>
    <div>
      <br>
      <b-table
        ref="refCalendarTable"
        class="position-relative"
        empty-text="No se encontraron resultados"
        responsive
        show-empty
        striped
        :items="calendario"
        :fields="columnas"
      >
        <template #cell(evento)="data">
          <span
            class="bullet bullet-sm mr-1"
            :style="`background-color: #${data.item.color };`"
          />
          {{ data.item.evento }}
        </template>
        <template #cell(fecha)="data">
          {{ timestampToDate(data.item.fecha) }}
        </template>
      </b-table>
    </div>
  </b-overlay>
</template>

<script>
import {
  BOverlay, BTable, BRow, BCol,
} from 'bootstrap-vue'
import { periodScheadule } from '@/views/public/oferta-academica/useDetalleOferta'
import selectplan from '@/views/components/select-plan.vue'
import selectperiodo from '@/views/components/select-periodos.vue'
import { timestampToDate } from '@core/utils/filter'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BTable,
    BOverlay,
    BRow,
    BCol,
    selectplan,
    selectperiodo,
  },
  data() {
    return {
      columnas: [
        { key: 'evento', label: 'Actividad', sortable: false },
        { key: 'fecha', label: 'Fecha', sortable: false },
      ],
      timestampToDate,
    }
  },
  setup() {
    const idplan = ref(null)
    const calendario = ref([])
    const loader = ref(false)

    const loadCalendario = idperiodo => {
      calendario.value = null
      periodScheadule(idperiodo).then(response => {
        loader.value = false
        calendario.value = response.calendario
      }, error => {
        if (error) loader.value = false
      })
    }
    return {
      calendario,
      loadCalendario,
      loader,
      idplan,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
